import axios from 'axios';
import React, { useEffect } from 'react';
import useStore from '../store/store';
import { Button, ButtonGroup } from '@chakra-ui/react';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby-link';
import Wrapper from '../layouts/Wrapper/Wrapper';
import PitchYourIdea from '../components/PitchYourIdea/PitchYourIdea';
import { useQuery } from 'react-query';
import QUERY_KEY from '../constants/query-key';
import { getURLParamObject, stripTrailingSlash } from '../helpers/helpers';
import PitchCard from '../components/PitchCard/PitchCard';
import { Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
import PitchNotFoundBanner from '../components/PitchNotFoundBanner/PitchNotFoundBanner';

export default function Pitches() {
  const location = useLocation();
  const endpoint = stripTrailingSlash(getURLParamObject(location.search).url);

  const pitches = useQuery(
    [QUERY_KEY.QUERY_KEY_FETCH_PITCHES],
    () => axios.get(`${endpoint}/pitches`).then((res) => res.data),
    {
      onSuccess: (res) => {},
      onError: () => {},
    },
  );
  const onPitchSubmit = () => {
    pitches.refetch();
  };

  return (
    <Wrapper>
      <PitchYourIdea onPitchSubmit={onPitchSubmit}></PitchYourIdea>
      <div className="container sm:max-w-3xl">
        <div className="flex flex-col gap-5">
          {pitches.isError ? (
            <PitchNotFoundBanner></PitchNotFoundBanner>
          ) : pitches.isSuccess ? (
            pitches.data.length == 0 ? (
              <div className="bg-white p-4 text-center ">
                <h4 className="font-normal">
                  Tap the <strong className="">Pitch Your Idea</strong> button
                  to create a new pitch.
                </h4>
              </div>
            ) : (
              pitches.data.map((ele, idx) => (
                <PitchCard key={ele.id} pitch={ele}></PitchCard>
              ))
            )
          ) : (
            <>
              <div className="flex flex-col gap-5">
                <Skeleton>
                  <div className="bg-white border h-[200px] rounded-md"></div>
                </Skeleton>
                <Skeleton>
                  <div className="bg-white border h-[200px] rounded-md"></div>
                </Skeleton>{' '}
                <Skeleton>
                  <div className="bg-white border h-[200px] rounded-md"></div>
                </Skeleton>
              </div>
            </>
          )}
        </div>
      </div>
    </Wrapper>
  );
}
